const routes = [
  {
    name: 'safety-analytics-root',
    path: '/risk-exposure',
    meta: {
      requiresAuth: true,
      layout: 'home',
      breadcrumb: {
        label: 'core.menu.modules.risk-exposure',
        route: 'safety-analytics',
      },
    },
    children: [
      {
        name: 'safety-analytics',
        path: '/risk-exposure/safety-analytics',
        meta: {
          allowedRoles: ['safety-analytics'],
          embedFullViewport: true,
          breadcrumb: {
            label: 'core.menu.modules.safety-analytics',
            route: 'safety-analytics',
          },
        },
        component: () =>
          import(
            '@/modules/safety-analytics/containers/safety-analytics.container.vue'
          ),
      },
    ],
  },
]

export default routes
